import { render, staticRenderFns } from "./ProNav.vue?vue&type=template&id=4bee2aca&"
import script from "./ProNav.vue?vue&type=script&lang=js&"
export * from "./ProNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports